import { render } from "./paragraph.vue?vue&type=template&id=a015d34a&scoped=true"
import script from "./paragraph.vue?vue&type=script&lang=js"
export * from "./paragraph.vue?vue&type=script&lang=js"

import "./paragraph.vue?vue&type=style&index=0&id=a015d34a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a015d34a"]])

export default __exports__